export default __webpack_public_path__ + "static/media/designersbanner.d95a0f3d.png";